export default "__VITE_ASSET__41c93893__"